export default __webpack_public_path__ + "static/media/blue_firework.fc7eb4eb.jpg";